import * as React from 'react';
import { FieldValidationType } from '../../../sic-lib/enums/FieldValidationType';
import DisplayPhoneNumber from '../../Shared/DisplayPhoneNumber/DisplayPhoneNumber';

interface Props {
    fieldValue: string;
    fieldType: FieldValidationType;
}

export default function DisplayContactFieldValue({ fieldValue, fieldType }: Props) {
    return (
        <React.Fragment>
            {fieldType == FieldValidationType.usMobilePhone ? (
                <DisplayPhoneNumber phoneNumber={fieldValue} />
            ) : (
                fieldValue
            )}
        </React.Fragment>
    );
}
